import { Component } from '@angular/core';

@Component({
  selector: 'app-investment-sectors',
  templateUrl: './investment-sectors.component.html',
  styleUrl: './investment-sectors.component.scss'
})
export class InvestmentSectorsComponent {

}
